import type { ReactNode } from "react";

import { Card } from "src/components/card";

type Props = {
  title: string;
  children: ReactNode;
};

/** A bordered card in the details panel, such as Tags or Fatigue curve. */
export function MediaDetailSection({ title, children }: Props) {
  return (
    <Card p={4} heading={title} gap={4}>
      {children}
    </Card>
  );
}
